export default __webpack_public_path__ + "static/media/no_course_for_approval.22031d2d.svg";